// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__b8X8I","eve":"Loader_eve__36dvb","upDown":"Loader_upDown__1oqN4"};